(function () {
  function initBeddingClearanceVariantPicker(root) {
    var product = root || document;
    var picker = product.querySelector('.product--bedding-clearance');

    if (!picker) return;
    if (picker.dataset.beddingClearanceVariantPickerInitialized === 'true') return;

    var sizeLabel = picker.querySelector('[data-bedding-clearance-size-label]');
    var productChoices = picker.querySelectorAll('[data-bedding-clearance-product-choice]');
    var singleValueOptionGroups = picker.querySelectorAll('[data-bedding-clearance-hide-when-single-value]');
    var optionGroups = Array.prototype.slice.call(picker.querySelectorAll('[dynamic-variant-input-wrap]'));
    var variantJson = picker.querySelector('[data-variant-json]');
    var parsedVariants = null;
    var isReconciling = false;
    var reconcileQueued = false;
    var typeDescriptionContent = {
      'quilt cover': {
        name: 'Pure Linen Quilt Cover Set',
        includes: ['1x Quilt Cover']
      },
      'quilt cover set': {
        name: 'Pure Linen Quilt Cover Set',
        includes: ['1x Quilt Cover', '2x Standard Pillowcases']
      },
      'quilt cover sets': {
        name: 'Pure Linen Quilt Cover Set',
        includes: ['1x Quilt Cover', '2x Standard Pillowcases']
      },
      'fitted sheet': {
        name: 'Pure Linen Fitted Sheet',
        includes: ['1x Fitted Sheet']
      },
      'flat sheet': {
        name: 'Pure Linen Flat Sheet',
        includes: ['1x Flat Sheet']
      },
      pillowcase: {
        name: 'Pure Linen Pillowcase Set',
        includes: ['2x Standard Pillowcases']
      },
      euros: {
        name: 'Pure Linen Euro Pillowcase',
        includes: ['1x Euro Pillowcase']
      }
    };

    if (!sizeLabel || !productChoices.length) return;
    picker.dataset.beddingClearanceVariantPickerInitialized = 'true';

    function updateSizeLabel(value) {
      if (!value) return;
      sizeLabel.textContent = 'CHOOSE ' + value.toUpperCase() + ' SIZE';
    }

    function selectChip(chip) {
      if (!chip || chip.classList.contains('selected')) return false;
      chip.click();
      return true;
    }

    function dispatchOptionChange(select) {
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function getVariants() {
      if (parsedVariants) return parsedVariants;
      if (!variantJson) return [];

      try {
        parsedVariants = JSON.parse(variantJson.textContent);
      } catch (error) {
        parsedVariants = [];
      }

      return parsedVariants;
    }

    function getGroupSelect(optionGroup) {
      return optionGroup.querySelector('select[dynamic-variant-input], select[name^="options["]');
    }

    function getVariantOptionValue(variant, index) {
      if (variant.options && variant.options[index] != null) return variant.options[index];
      return variant['option' + (index + 1)];
    }

    function getSelectedOptionValues() {
      return optionGroups.map(function (optionGroup) {
        var select = getGroupSelect(optionGroup);
        return select ? select.value : '';
      });
    }

    function getSelectedProductType() {
      var selectedValues = getSelectedOptionValues();
      var selectedChoice = picker.querySelector('[data-bedding-clearance-product-choice].selected');

      return selectedValues[0] || (selectedChoice && selectedChoice.dataset.optionValue) || '';
    }

    function normalizeTypeValue(value) {
      return (value || '')
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    function getTypeDescriptionContent(typeValue) {
      return typeDescriptionContent[normalizeTypeValue(typeValue)] || null;
    }

    function findTextNode(container, values) {
      var nodes = Array.prototype.slice.call(container.childNodes);

      for (var index = 0; index < nodes.length; index += 1) {
        var node = nodes[index];

        if (node.nodeType === 3) {
          var text = node.nodeValue;
          var normalizedText = text.toLowerCase();
          var matchValue = values.find(function (value) {
            return normalizedText.indexOf(value.toLowerCase()) > -1;
          });

          if (matchValue) {
            var matchIndex = normalizedText.indexOf(matchValue.toLowerCase());
            return {
              node: node,
              match: text.slice(matchIndex, matchIndex + matchValue.length)
            };
          }
        } else if (node.nodeType === 1) {
          var childMatch = findTextNode(node, values);
          if (childMatch) return childMatch;
        }
      }

      return null;
    }

    function wrapTypeName(container) {
      if (container.querySelector('[data-bedding-clearance-description-type-name]')) return;

      var match = findTextNode(container, ['Pure Linen Quilt Cover Sets', 'Pure Linen Quilt Cover Set']);
      if (!match) return;

      var node = match.node;
      var text = node.nodeValue;
      var matchIndex = text.indexOf(match.match);
      var before = text.slice(0, matchIndex);
      var after = text.slice(matchIndex + match.match.length);
      var typeName = document.createElement('span');

      typeName.setAttribute('data-bedding-clearance-description-type-name', '');
      typeName.setAttribute('data-original-text', match.match);
      typeName.textContent = match.match;

      if (before) {
        node.parentNode.insertBefore(document.createTextNode(before), node);
      }

      node.parentNode.insertBefore(typeName, node);

      if (after) {
        node.parentNode.insertBefore(document.createTextNode(after), node);
      }

      node.parentNode.removeChild(node);
    }

    function getClosestDescriptionBlock(node, container) {
      var element = node.nodeType === 1 ? node : node.parentElement;

      while (element && element !== container) {
        if (/^(P|DIV|UL|OL)$/i.test(element.tagName)) return element;
        element = element.parentElement;
      }

      return null;
    }

    function findIncludesBlock(container) {
      var match = findTextNode(container, ['Includes:']);
      return match ? getClosestDescriptionBlock(match.node, container) : null;
    }

    function hideOriginalIncludes(labelBlock) {
      var nextBlock;

      if (!labelBlock || labelBlock.dataset.beddingClearanceOriginalIncludes === 'true') return;

      labelBlock.hidden = true;
      labelBlock.dataset.beddingClearanceOriginalIncludes = 'true';
      nextBlock = labelBlock.nextElementSibling;

      if (nextBlock && /^(UL|OL)$/i.test(nextBlock.tagName)) {
        nextBlock.hidden = true;
        nextBlock.dataset.beddingClearanceOriginalIncludes = 'true';
      }
    }

    function createIncludesPanel(target) {
      var panel = target || document.createElement('div');
      var heading;
      var list;

      panel.classList.add('bedding-clearance-description-includes');
      panel.setAttribute('data-bedding-clearance-description-includes', '');

      heading = panel.querySelector('.bedding-clearance-description-includes__heading');
      list = panel.querySelector('.bedding-clearance-description-includes__items');

      if (!heading) {
        heading = document.createElement('p');
        heading.className = 'bedding-clearance-description-includes__heading';
        heading.textContent = 'Includes:';
        panel.appendChild(heading);
      }

      if (!list) {
        list = document.createElement('ul');
        list.className = 'bedding-clearance-description-includes__items';
        panel.appendChild(list);
      }

      return panel;
    }

    function insertIncludesPanel(container) {
      var existingPanel = container.querySelector('[data-bedding-clearance-description-includes]');
      var placeholder = container.querySelector('.package-includes');
      var labelBlock;
      var paragraphs;
      var insertionTarget;
      var panel;

      if (existingPanel) return existingPanel;

      labelBlock = findIncludesBlock(container);

      if (placeholder) {
        panel = createIncludesPanel(placeholder);
        hideOriginalIncludes(labelBlock);
        return panel;
      }

      panel = createIncludesPanel();

      if (labelBlock && labelBlock.parentNode) {
        labelBlock.parentNode.insertBefore(panel, labelBlock);
        hideOriginalIncludes(labelBlock);
      } else {
        paragraphs = container.querySelectorAll('p');
        insertionTarget = paragraphs.length > 1 ? paragraphs[1].nextSibling : container.firstChild;
        container.insertBefore(panel, insertionTarget);
      }

      return panel;
    }

    function prepareDescriptionContainer(container) {
      if (container.dataset.beddingClearanceDescriptionReady === 'true') {
        return container.querySelector('[data-bedding-clearance-description-includes]');
      }

      wrapTypeName(container);
      container.dataset.beddingClearanceDescriptionReady = 'true';

      return insertIncludesPanel(container);
    }

    function syncTypeDescription(typeValue) {
      var content = getTypeDescriptionContent(typeValue);
      var containers = document.querySelectorAll('[data-bedding-clearance-description]');

      containers.forEach(function (container) {
        var panel = prepareDescriptionContainer(container);
        var typeName = container.querySelector('[data-bedding-clearance-description-type-name]');
        var list = panel && panel.querySelector('.bedding-clearance-description-includes__items');

        if (typeName) {
          typeName.textContent = content ? content.name : typeName.dataset.originalText;
        }

        if (!panel || !list) return;

        list.innerHTML = '';

        if (!content) {
          panel.hidden = true;
          return;
        }

        panel.hidden = false;
        content.includes.forEach(function (item) {
          var listItem = document.createElement('li');
          listItem.textContent = item;
          list.appendChild(listItem);
        });
      });
    }

    function findPreferredAvailableValues() {
      var selectedValues = getSelectedOptionValues();
      var selectedProduct = selectedValues[0];
      var variants = getVariants();

      if (!selectedProduct || !variants.length) return null;

      var candidates = variants.filter(function (variant) {
        return variant.available !== false && getVariantOptionValue(variant, 0) === selectedProduct;
      });

      if (!candidates.length) return null;

      var preferredValues = [selectedProduct];

      for (var index = 1; index < optionGroups.length; index += 1) {
        var selectedValue = selectedValues[index];
        var selectedCandidates = candidates.filter(function (variant) {
          return getVariantOptionValue(variant, index) === selectedValue;
        });

        if (selectedValue && selectedCandidates.length) {
          preferredValues[index] = selectedValue;
          candidates = selectedCandidates;
        } else {
          preferredValues[index] = getVariantOptionValue(candidates[0], index);
          candidates = candidates.filter(function (variant) {
            return getVariantOptionValue(variant, index) === preferredValues[index];
          });
        }
      }

      return preferredValues;
    }

    function selectOptionValue(index, value) {
      var optionGroup = optionGroups[index];
      if (!optionGroup || !value) return false;

      var select = getGroupSelect(optionGroup);
      var changed = false;
      var matchingButton = Array.prototype.find.call(optionGroup.querySelectorAll('[dynamic-variant-button]'), function (button) {
        return button.dataset.optionValue === value;
      });

      if (matchingButton) {
        changed = selectChip(matchingButton) || changed;
      }

      if (select && select.value !== value) {
        select.value = value;
        dispatchOptionChange(select);
        changed = true;
      }

      return changed;
    }

    function syncProductChoiceValue(choice) {
      var select = getGroupSelect(optionGroups[0]);
      var value = choice.dataset.optionValue || choice.getAttribute('data-label');

      if (!select || !value || select.value === value) return;

      select.value = value;
      dispatchOptionChange(select);
    }

    function reconcileVariantSelection() {
      var preferredValues = findPreferredAvailableValues();
      if (!preferredValues || isReconciling) return;

      isReconciling = true;

      for (var index = 1; index < preferredValues.length; index += 1) {
        selectOptionValue(index, preferredValues[index]);
      }

      isReconciling = false;
    }

    function syncSingleValueOptionVisibility() {
      singleValueOptionGroups.forEach(function (optionGroup) {
        var chips = optionGroup.querySelectorAll('.product__chip');
        var availableChips = Array.prototype.filter.call(chips, function (chip) {
          return !chip.classList.contains('disabled') && chip.getAttribute('aria-disabled') !== 'true' && !chip.disabled;
        });
        var shouldHide = availableChips.length <= 1;

        if (shouldHide && availableChips.length === 1) {
          selectChip(availableChips[0]);
        }

        optionGroup.hidden = shouldHide;
        optionGroup.classList.toggle('product__option--single-value-hidden', shouldHide);
      });
    }

    function queueVariantOptionSync() {
      if (reconcileQueued) return;
      reconcileQueued = true;

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          reconcileQueued = false;
          reconcileVariantSelection();
          syncSingleValueOptionVisibility();
        });
      });
    }

    function syncAfterProductChoice() {
      window.setTimeout(function () {
        reconcileVariantSelection();
        syncSingleValueOptionVisibility();
        syncTypeDescription(getSelectedProductType());
        queueVariantOptionSync();
      }, 0);
    }

    productChoices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        updateSizeLabel(choice.getAttribute('data-label'));
        syncProductChoiceValue(choice);
        syncTypeDescription(choice.dataset.optionValue || choice.getAttribute('data-label'));
        syncAfterProductChoice();
      });
    });

    singleValueOptionGroups.forEach(function (optionGroup) {
      optionGroup.addEventListener('click', queueVariantOptionSync);
    });

    var observer = new MutationObserver(queueVariantOptionSync);
    singleValueOptionGroups.forEach(function (optionGroup) {
      observer.observe(optionGroup, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
    });

    var selectedChoice = picker.querySelector('[data-bedding-clearance-product-choice].selected');
    if (selectedChoice) {
      updateSizeLabel(selectedChoice.getAttribute('data-label'));
    }

    syncSingleValueOptionVisibility();
    syncTypeDescription(getSelectedProductType());
    queueVariantOptionSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBeddingClearanceVariantPicker(document);
    });
  } else {
    initBeddingClearanceVariantPicker(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBeddingClearanceVariantPicker(event.target);
  });
})();
